import React, { Component } from "react";
import Transition from 'react-transition-group/Transition';

// Styles
import './pricer.css';

// The pricer component is stateless and receives all
// details from prices class
class Pricer extends Component {
    
    constructor(props) {

        super(props);

        this.state = {};
    }
    

    // After first render() is successfully executed, this function is called
    componentDidMount() {

        //console.log('Pricer.componentDidMount() - ' + this.props.currency.ticker);
    }


    // Determines whether or not to re-render component
    shouldComponentUpdate(nextProps, nextState){

        // return a boolean value
        if(nextProps.currency.price !== this.props.currency.price || nextProps.currency.change !== this.props.currency.change) {

            //console.log('Pricer.shouldComponentUpdate(true) - ' + this.props.currency.ticker);
            return true;

        }
        else {
            return false;

        }
        
    }

    // Renders the pricer object
    render() {

        console.log('Pricer.render() - ' + this.props.currency.ticker);

        var currency = this.props.currency;

        return (

            <div className="flex-panel">
            
                <div className="child-row">

                    <div className="column-box left">

                        <div className="price-image">
                            <img src={'/assets/img/coins/' + currency.ticker + '.png'} className="img-circle img-xs" alt=""></img>
                        </div>

                        <div className="row-box left">
                        
                            <div>
                                {currency.name}
                            </div>

                            <div className="italic lowlight">
                                {currency.ticker}
                            </div>
    
                        </div>

                    </div>

                    <Transition timeout={750} in={currency.blink} mountOnEnter={true} appear={true}>
                    {(status) => (
                        <div className="row-box right">

                            <div className={`blinker blink-${status}`} >
                                <span className="right-pad">{this.props.currencySymbol}</span>
                                <span>{currency.price}</span>
                                <i className={currency.change > 0 ? 'icon-arrow-up8 green-text left-pad arrow hover-up' : 'icon-arrow-down8 red-text left-pad arrow hover-down'}></i>
                            </div>

                            <div className={`lowlight blinker blink-${status}`}>
                                {currency.change}
                                <span className="left-pad">%</span>
                            </div>

                        </div>
                    )}
                    </Transition>
                    


                </div>

            </div>
        );
    }

}

export default Pricer;








// WEBPACK FOOTER //
// ./src/Views/Prices/Pricer.js